/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */

import {useState, useEffect, useRef, Fragment} from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import MDTypography from "components/MDTypography";

export default function Loading({title}) {

function GradientCircularProgress() {
  return (
    <Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#0097a7" />
            <stop offset="100%" stopColor="#3f51b5" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}  />
    </Fragment>
  );
}
  return (
     <Box sx={{ display: 'block', textAlign:"center" }}>
      <GradientCircularProgress />
       <Box sx={{ display: 'block', textAlign:"center" }}>
        <MDTypography variant="button" color="text" fontWeight="regular">
            <strong>{title}</strong> 
        </MDTypography>
        </Box>
    </Box>
  );
}

